import { Component } from '@angular/core';
import { ListComponent } from './list.component';

@Component({
  selector: 'smt-custom-list',
  templateUrl: './custom-list.component.html',
  styleUrls: ['./custom-list.component.scss']
})
export class CustomListComponent extends ListComponent {}